import { NOVITA_UNREAD_STALE_TIME_MS } from './config';
import { subscribeNovitaState } from './events';
import { getCurrentNovitaSessionKey, getNovitaUnreadState } from './state';
import {
  bindNovitaUIEvents,
  updateNovitaSessionKey,
  updateNovitaStateUI,
} from './ui';

let lastRefreshAt = 0;
let lastSessionKey = null;
let refreshPromise = null;
let stateSubscriptionBound = false;

export const refreshNovitaUnreadState = async ({ force = false } = {}) => {
  const sessionKey = await getCurrentNovitaSessionKey();
  updateNovitaSessionKey(sessionKey);

  const now = Date.now();
  const canUseCache =
    !force &&
    sessionKey &&
    lastSessionKey === sessionKey &&
    now - lastRefreshAt < NOVITA_UNREAD_STALE_TIME_MS;

  if (canUseCache) return;

  if (!refreshPromise) {
    refreshPromise = getNovitaUnreadState()
      .then((state) => {
        lastSessionKey = sessionKey;
        lastRefreshAt = Date.now();
        updateNovitaStateUI(state);
      })
      .catch((error) => {
        console.warn('[novita] unread state unavailable', error);
        updateNovitaStateUI(null);
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  await refreshPromise;
};

export const initNovita = async () => {
  if (!stateSubscriptionBound) {
    subscribeNovitaState(updateNovitaStateUI);
    stateSubscriptionBound = true;
  }

  bindNovitaUIEvents();
  await refreshNovitaUnreadState();
};

export { refreshNovitaUnreadState as refreshNovita };
